import * as ActionTypes from './team.actionTypes';
import * as UserActionTypes from '../user/user.actionTypes';
import * as AuthActionTypes from '../auth/auth.actionTypes';
import { combineReducers } from 'redux';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import values from 'lodash/values';
import omit from 'lodash/omit';
import without from 'lodash/without';

const allIds = (state = [], action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return [];
  }

  switch (action.type) {
    case ActionTypes.CREATE_TEAM_SUCCESS:
      return [...state, action.response.result];
    case ActionTypes.DELETE_TEAM_SUCCESS:
    case ActionTypes.DELETE_TEAM_FAILURE:
      //TODO remove entry
      const deletedIndex = state.indexOf(action.payload.id);
      if (deletedIndex === -1) {
        return state;
      }
      return [...state.slice(0, deletedIndex), ...state.slice(deletedIndex + 1)];
    case ActionTypes.READ_TEAM_SUCCESS:
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    case ActionTypes.READ_TEAMS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return {};
  }

  // promoted & removed from team
  if (action.response && action.response.entities && action.response.entities.user && !action.response.entities.team) {
    if (action.type === UserActionTypes.UPDATE_USER_SUCCESS) {
      // fetch reference to the single updated user
      const updatedUser = action.response.entities.user && values(action.response.entities.user)[0];
      let changedTeams = {};
      if (updatedUser) {
        // updatedUser always exsits unless server fails
        // resolve new and old team
        let oldTeam = values(state).find(team => {
          return team.members && team.members.includes(updatedUser._id);
        });

        if (oldTeam) {
          // make a deep clone so that we don't mutate the state in reducer
          oldTeam = merge({}, oldTeam);
          oldTeam.members = without(oldTeam.members, updatedUser._id);
          changedTeams[oldTeam._id] = oldTeam;
        }
      }
      return Object.assign({}, state, changedTeams);
    }
    return state;
  }

  // change team
  if (action.response && action.response.entities && action.response.entities.team) {
    let changedTeams = action.response.entities.team;
    if (action.type === UserActionTypes.UPDATE_USER_SUCCESS) {
      // reassign changedTeams into a new object
      changedTeams = {};
      // fetch reference to the single updated user
      const updatedUser = action.response.entities.user && values(action.response.entities.user)[0];
      if (updatedUser) {
        // updatedUser always exsits unless server fails
        // resolve new and old team
        let newTeamKey = updatedUser.team,
          newTeam = state[newTeamKey] || action.response.entities.team[newTeamKey],
          oldTeam = values(state).find(team => {
            return team.members && team.members.includes(updatedUser._id);
          });

        if (!newTeam || !oldTeam || newTeam._id !== oldTeam._id) {
          if (oldTeam) {
            // make a deep clone so that we don't mutate the state in reducer
            oldTeam = merge({}, oldTeam);
            oldTeam.members = without(oldTeam.members, updatedUser._id);
            changedTeams[oldTeam._id] = oldTeam;
          }

          if (newTeam) {
            // make a deep clone so that we don't mutate the state in reducer
            newTeam = merge({ members: [] }, newTeam);
            newTeam.members.push(updatedUser._id);
            changedTeams[newTeam._id] = newTeam;
          }
        }
      }
      return Object.assign({}, state, changedTeams);
    }

    if (action.response.method && action.response.method === 'DELETE') {
      console.log('//DELETE ENTITIES FROM STATE', state, action.response.entities);
      return omit(state, keys(action.response.entities.team));
    }
    return merge({}, state, changedTeams);
  }

  return state;
};

const ranking = (state = {}, action) => {
  if (action.response && action.response.entities && action.response.entities.ranking) {
    //TODO
    // if(action.response.method && action.response.method === 'DELETE') {
    //   console.log("//DELETE ENTITIES FROM STATE", state, action.response.entities);
    //   return omit(state, keys(action.response.entities.team));
    // }
    return merge({}, state, action.response.entities.ranking);
  }
  return state;
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_TEAMS_REQUEST:
      return true;
    case ActionTypes.READ_TEAMS_SUCCESS:
    case ActionTypes.READ_TEAMS_FAILURE:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  byId,
  ranking,
  isFetching,
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/team/team.reducer.js